import { Journey } from '@audibene/ta.utils-opportunity'
import { Country } from '../../../../constants'
import { AppointmentTypes } from '../../../../types'
import { HttpClientConfig } from '../../../useHttpClientConfig'
import { apiVersion, service } from '../service'
import { applySearchParams, FilterValue, urlToPathnameAndSearch } from '../utils'
import { isNil } from 'remeda'

type AppointmentTypeFilters = {
  country: FilterValue
  journey: FilterValue
  shopType?: FilterValue
}

const pathname = `/api/${apiVersion}/appointment-types`

const defaults: AppointmentTypeFilters = {
  country: Country.US,
  journey: Journey.TELEAUDIOLOGY_HEAR_TODAY,
}

const makeGetAppointmentTypes =
  (baseUrl: string, config: HttpClientConfig) =>
  async (filters: AppointmentTypeFilters): Promise<AppointmentTypes> => {
    const actualFilters = { ...defaults, ...filters }

    if (isNil(actualFilters.shopType)) delete actualFilters.shopType

    const url = new URL(pathname, baseUrl)

    applySearchParams(url, actualFilters)

    const pathnameAndSearch = urlToPathnameAndSearch(url)
    const { data } = await service(baseUrl).get<AppointmentTypes>(pathnameAndSearch, config)

    return data
  }

export type { AppointmentTypeFilters }
export { makeGetAppointmentTypes }
